// =============================================================
//  HEGEMONYS THEME — GLOBAL JAVASCRIPT
//  Header, mobile menu, cart drawer, scroll reveal.
//  Product-page behaviour lives in sections/main-product.liquid.
// =============================================================

document.addEventListener('DOMContentLoaded', function () {

  // --- Sticky Header ---
  var header = document.querySelector('.fixed-header-wrapper');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // --- Mobile Menu Toggle ---
  var menuToggle = document.getElementById('mobile-menu-toggle');
  var mobileMenu = document.getElementById('mobile-menu');
  if (menuToggle && mobileMenu) {
    // Move out of the fixed header to avoid iOS backdrop-filter clipping
    document.body.appendChild(mobileMenu);
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('open');
      menuToggle.classList.toggle('open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
      document.documentElement.style.overflow = isOpen ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        menuToggle.classList.remove('open');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      });
    });
  }

  // --- Cart Drawer ---
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartClose = document.getElementById('cart-close');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  window.HegemonyOpenCart = openCart;

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', openCart);
  });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function renderCart(cart) {
    var body = document.getElementById('cart-drawer-body');
    var subtotalEl = document.getElementById('cart-subtotal');
    var countEl = document.getElementById('cart-count');

    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty"><p>Your cart is empty.</p>' +
        '<a href="/collections/all" style="margin-top:2rem;display:inline-block;font-size:0.625rem;font-weight:900;letter-spacing:0.3em;text-transform:uppercase;color:var(--gold);border-bottom:1px solid var(--gold);padding-bottom:4px;">Explore the archive</a></div>';
      if (subtotalEl) subtotalEl.textContent = '$0.00';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var variantStr = (item.options_with_values || [])
        .filter(function (o) {
          var n = (o.name || '').toLowerCase();
          return n !== 'product' && n !== 'title' && o.value && o.value !== 'Default Title';
        })
        .map(function (o) { return o.value; })
        .join(' / ');
      return '' +
        '<div class="cart-item" data-key="' + item.key + '">' +
          '<div class="cart-item__image"><img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80"></div>' +
          '<div class="cart-item__info">' +
            '<p class="cart-item__name">' + escapeHtml(item.product_title) + '</p>' +
            (variantStr ? '<p class="cart-item__variant">' + escapeHtml(variantStr) + '</p>' : '') +
            '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
            '<div class="cart-item__qty">' +
              '<button class="qty-decrease" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button class="qty-increase" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    body.querySelectorAll('.qty-decrease').forEach(function (btn) {
      btn.addEventListener('click', function () { updateCart(btn.dataset.key, parseInt(btn.dataset.qty, 10) - 1); });
    });
    body.querySelectorAll('.qty-increase').forEach(function (btn) {
      btn.addEventListener('click', function () { updateCart(btn.dataset.key, parseInt(btn.dataset.qty, 10) + 1); });
    });
  }

  function updateCart(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // --- Scroll Reveal (progressive enhancement) ---
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var reveals = document.querySelectorAll('.reveal');
    reveals.forEach(function (el) { el.classList.add('will-animate'); });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
    reveals.forEach(function (el) { observer.observe(el); });
  }

  // --- Initial cart count ---
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    var countEl = document.getElementById('cart-count');
    if (countEl && cart.item_count > 0) {
      countEl.textContent = cart.item_count;
      countEl.style.display = 'flex';
    }
  }).catch(function () {});

});
